module.exports = __webpack_public_path__ + "static/media/huanjing5.a61a445c.png";